const axios = require("axios");

export default function commonRequest(
  basePath,
  options,
  uri,
  onSuccess,
  onError,
  headers
) {
  const requestUrl = `${basePath}/${uri}`;
  const method = (options && options.method) || "get";
  const data = options && options.data;

  onSuccess = onSuccess || function () {};

  onError =
    onError ||
    function (err) {
      console.error("General Error", err);
    };

  if (method.toLowerCase() === "get") {
    return axios
      .get(requestUrl, { headers: { ...headers } })
      .then((res) => onSuccess(res))
      .catch((err, res) => onError(err, res));
  }

  if (method.toLowerCase() === "post") {
    return axios
      .post(requestUrl, data, { ...headers })
      .then((res) => onSuccess(res))
      .catch((err, res) => onError(err, res));
  }
}
